<template>
  <div class="awards">
    <!-- 操作栏容器 -->
    <div class="awards-info-operation-container">
      <div class="awards-info-search-container">
        <!-- 搜索框 -->
        <search class="student-search" :placeholder="studentNamePlaceholder" @search="studentNameSearch" />
        <search class="student-search" :placeholder="competitionPlaceholder" @search="competitionSearch" />
        <search class="student-search" :placeholder="awardsPlaceholder" @search="awardsSearch" />
        <search class="student-search" :placeholder="presentationUnit" @search="presentationUnitSearch" />
        <!-- <el-date-picker
          class="student-search"
          v-model="searchInfo.awardTime"
          type="date"
          placeholder="选择获奖时间"
          value-format="yyyy-MM-dd"
          @change="refresh"
        >
        </el-date-picker> -->
        <el-cascader class="select" v-model="className" placeholder="选择班级" :props="classProps" :options="classSelect"
          @change="changeHandle" clearable></el-cascader>
        <!-- <el-date-picker
          style="width: 100px; margin-left: 10px"
          v-model="searchInfo.schoolYear"
          type="year"
          placeholder="学年"
          @change="schoolYearChangeHandle"
        >
        </el-date-picker> -->
        <el-select style="width: 105px; margin-left: 10px" v-model="searchInfo.semester" placeholder="学期" clearable
          @change="semesterChangeHandle">
          <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
        <year-range-picker style="width: 250px;margin-left: 10px" v-model="searchInfo.schoolYear"
          @change="schoolYearChangeHandle" />
      </div>
      <div class="awards-info-button-container">
        <button class="button add-awards" @click="addAwardsDialogShow" v-hasPermi="'sc:medal:add'">
          <i class="iconfont icon-add"></i>新增获奖
        </button>
        <!-- 批量删除 -->
        <button class="button delete-awards" @click="deleteClick" v-hasPermi="'sc:medal:delete'">
          <i class="iconfont icon-delete" />批量删除
        </button>
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="awards-info-table-container" v-bitmap="getListResult">
      <awardsList class="awards-list" v-show="total" :medalList="medalList" @multipleDelete="multipleDelete" />
    </div>
    <!-- 分页容器 -->
    <div class="awards-info-pagination-catainer">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageSize)" @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange" />
    </div>
    <addAwardsDialog :classSelect="classSelect" :studentList="studentList"
      :isAddAwardsDialogShow.sync="isAddAwardsDialogShow" v-show="isAddAwardsDialogShow" @formSubmit="formSubmit"
      @changeClass="changeClass" :semesterOptions="semesterOptions" :schoolYear="searchInfo.schoolYear"
      :semester="searchInfo.semester" />
  </div>
</template>

<script>
// 搜索框
import search from "@/components/search/search.vue";
import pagination from "@/components/pagination/pagination";
import awardsList from "./components//awards-list/awardsList.vue";
import addAwardsDialog from "./components/addAwards-dialog/addAwards-dialog.vue";
export default {
  components: {
    search,
    pagination,
    awardsList,
    addAwardsDialog,
  },
  data() {
    return {
      studentNamePlaceholder: "学生姓名",
      competitionPlaceholder: "比赛名称",
      awardsPlaceholder: "获取奖项",
      presentationUnit: "颁奖单位",
      getListResult: "nullData",
      total: 0, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页条数
      // 班级年级数据
      classSelectList: [],
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 搜索条件
      searchInfo: {
        gradeId: "",
        classId: "",
        studentName: "",
        competition: "",
        awards: "",
        presentation: "",
        awardTime: "",
        schoolYear: "", // 学年
        semester: "", // 学期
      },
      medalList: [],
      deleteList: [], // 学生批量删除列表
      isAddAwardsDialogShow: false,
      studentList: [],
      classData: {
        classId: "",
      },
      semesterOptions: [],
    };
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    this.getSchoolDetails();
    this.selectSchoolAndGradeAndClassListPC();
    this.selectStudentListPC();
    this.getDictType();
  },
  methods: {
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        let schoolInfo = res.data;
        this.searchInfo.semester = schoolInfo.semester;
        this.searchInfo.schoolYear = schoolInfo.schoolYear;
        // 先获取学年学期，再获取获奖情况
        this.getMedalList();
      });
    },
    // 获取学期类型选择列表数据
    getDictType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    changeClass(id) {
      this.classData.classId = id;
      this.selectStudentListPC();
    },
    formSubmit(data) {
      let {
        studentId,
        competitionName,
        medal,
        gainDate,
        presentationUnit,
        className,
        schoolYear,
        semester,
      } = data;
      this.post(this.$url.addMedal, {
        studentId,
        competitionName,
        medal,
        gainDate,
        presentationUnit,
        schoolYear,
        semester,
        schoolId: this.user.schoolId,
        classId: className[1].classId,
        gradeId: className[0].gradeId,
      }).then((res) => {
        // console.log(res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success("添加成功");
        this.refresh();
      });
    },
    schoolYearChangeHandle(e) {
      // console.log(e);
      // this.searchInfo.schoolYear = e ? "" + e.getFullYear() : "";
      this.refresh();
    },
    semesterChangeHandle(e) {
      this.searchInfo.semester = e;
      this.refresh();
    },
    studentNameSearch(e) {
      this.searchInfo.studentName = e;
      // 刷新列表
      this.refresh();
    },
    competitionSearch(e) {
      this.searchInfo.competition = e;
      // 刷新列表
      this.refresh();
    },
    awardsSearch(e) {
      this.searchInfo.awards = e;
      // 刷新列表
      this.refresh();
    },
    presentationUnitSearch(e) {
      this.searchInfo.presentation = e;
      // 刷新列表
      this.refresh();
    },
    // 显示添加弹出框
    addAwardsDialogShow() {
      this.isAddAwardsDialogShow = true;
    },
    // 选择班级
    changeHandle(e) {
      // console.log("选中的班级==>", e);
      if (e.length != 0) {
        this.searchInfo.gradeId = e[0].gradeId;
        this.searchInfo.classId = e[1].classId;
      } else {
        this.searchInfo.gradeId = "";
        this.searchInfo.classId = "";
      }

      this.refresh();
    },
    multipleDelete(res) {
      this.deleteList = res;
    },
    // 批量删除
    deleteClick() {
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要删除的学生获奖情况");
      }
      this.$confirm("是否删除选中的学生获奖情况?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除接口
          this.delete(this.$url.delMedal + "/" + this.deleteList)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
    refresh() {
      this.pageNum = 1;
      this.total = 0;
      this.medalList = [];
      this.isAddAwardsDialogShow = false;
      this.getMedalList();
    },
    // 获取学生获奖列表
    getMedalList() {
      let {
        gradeId,
        classId,
        studentName,
        competition,
        awards,
        presentation,
        awardTime,
        schoolYear,
        semester,
      } = this.searchInfo;
      let data = {
        schoolId: this.user.schoolId,
        gradeId, // 年级ID
        classId, // 班级ID
        competitionName: competition, // 比赛名称
        medal: awards, // 获取奖项名称
        gainDate: awardTime, // 获奖时间
        studentName, // 学生名字
        presentationUnit: presentation, // 颁奖单位
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        schoolYear,
        semester,
      };
      // this.getListResult = "loading";
      this.get(this.$url.getMedalList, data).then((res) => {
        if (res.code !== 200) {
          this.getListResult = "error";
          return this.$message.error(res.msg);
        }
        // console.log("获取学生获奖列表==>", res);
        this.total = res.total;
        if (this.total <= 0) return (this.getListResult = "nullData");
        this.getListResult = "success";
        this.medalList = res.rows;
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getMedalList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getMedalList();
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          this.classSelectList = res.data;
          this.classSelectListLength = this.classSelectList.length;
          // console.log(this.classSelectList.length);
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // console.log("处理后的数据==>", this.classSelect);
          }
        })
        .catch((err) => {
          // this.$message.error("获取班级列表失败");
        });
    },
    // 获取学生列表
    selectStudentListPC() {
      this.get(this.$url.selectStudentListPC, {
        schoolId: this.user.schoolId,
        schoolName: this.user.schoolName,
        classId: this.classData.classId,
      }).then((res) => {
        // console.log("学生列表==>", res);
        if (res.code !== 200) {
          return this.$message.error(res.msg);
        }
        this.studentList = res.rows;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./awards.scss";
</style>
